import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { useListUser } from "stores/hooks/list-user";
import { faBoxArchive } from "components/icon-library";
import Datepicker from "components/forms/inputs/datepicker";

interface ArchiveModalFormProps {
  onSubmit: (archived_at: any) => Promise<any>;
  onClose: () => Promise<void>;
}

const ArchiveModalForm: FunctionComponent<ArchiveModalFormProps> = ({
  onClose,
  onSubmit,
}) => {
  const user = useListUser();

  const schema = yup
    .object({ archived_at: yup.date().validateRequired() })
    .required();

  const methods = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: { archived_at: new Date() },
  });

  const handleSubmit = async (values: any) => {
    onSubmit(values.archived_at);
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, text: "Vahvista", postIcon: faBoxArchive },
  ];

  if (!user) {
    return null;
  }

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            Voit merkitä ilmoitusvelvollisen tehtävän päättyneeksi, jolloin
            ilmoitusvelvollinen ei ole enää aktiivisesti osa luetteloa. Voit
            myöhemmin palauttaa ilmoitusvelvollisen osaksi luetteloa.
          </Col>
        </Row>
        <Row>
          <Col>
            <Datepicker name="archived_at" label="Tehtävän päättymispäivä" />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default ArchiveModalForm;
